import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import Header from "../../../components/Header";
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import { mpesaPay } from "../../../data/DynamicTable/DynamicFunctions";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import { setupManagementUrl } from "../../../config";
const setup_url = setupManagementUrl.uri;

const SubscriptionForm = ({ onClose }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [subscriptionsData, setSubscriptionsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  // Subscription plans
   useEffect(() => {
      async function fetchAllData() {
        try {
          const subscriptionsDataResponse = await fetchJsonDynamic(
            "allSubscriptionPlans",
            null,
            null,
            setup_url
          );
          if (subscriptionsDataResponse?.results) {
            const results = JSON.parse(subscriptionsDataResponse?.results);
            setSubscriptionsData(results || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchAllData();
    }, []);

  // Validation schema
  const validationSchema = yup.object().shape({
    phoneNumber: yup
      .string()
      .matches(/^(?:254|0)[7]\d{8}$/, "Invalid phone number format")
      .required("Phone number is required"),
    amount: yup
      .number()
      .typeError("Amount must be a number")
      .positive("Amount must be greater than zero")
      .required("Amount is required"),
    subscriptionPlan: yup
      .number()
      .required("Please select a subscription plan"),
  });

  const handleTopUp = async (values, { setSubmitting }) => {
    const { phoneNumber, amount, subscriptionPlan } = values;

    try {
      const response = await mpesaPay(amount, phoneNumber, subscriptionPlan);
      if (response.status === 200) {
        Swal.fire("Success!", "Payment initiated successfully!", "success");
        onClose?.(); // Close modal if applicable
      } else {
        Swal.fire("Error!", "Payment failed! Please try again.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "Please contact the Admin.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <Header title="Subscribe" subtitle="Enter your details to subscribe" />

      <Formik
        initialValues={{ phoneNumber: "", amount: "", subscriptionPlan: "" }}
        validationSchema={validationSchema}
        onSubmit={handleTopUp}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Phone Number"
              name="phoneNumber"
              value={values.phoneNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.phoneNumber && Boolean(errors.phoneNumber)}
              helperText={touched.phoneNumber && errors.phoneNumber}
              margin="normal"
            />

          <FormControl fullWidth margin="normal">
            <InputLabel>Subscription Plan</InputLabel>
            <Select
              name="subscriptionPlan"
              value={values.subscriptionPlan}
              onChange={(e) => {
                const selectedPlan = subscriptionsData.find(
                  (plan) => plan.Id === e.target.value
                );
                setFieldValue("subscriptionPlan", e.target.value);
                setFieldValue("amount", selectedPlan ? selectedPlan.Price : "");
              }}
              onBlur={handleBlur}
              error={touched.subscriptionPlan && Boolean(errors.subscriptionPlan)}
            >
              {subscriptionsData.map((plan) => (
                <MenuItem key={plan.Id} value={plan.Id}>
                  {plan.PlanName}
                </MenuItem>
              ))}
            </Select>
            {touched.subscriptionPlan && errors.subscriptionPlan && (
              <Typography color="error">{errors.subscriptionPlan}</Typography>
            )}
          </FormControl>


            <TextField
              fullWidth
              label="Amount"
              name="amount"
              type="number"
              value={values.amount}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.amount && Boolean(errors.amount)}
              helperText={touched.amount && errors.amount}
              margin="normal"
              disabled
            />

            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? "Processing..." : "Subscribe"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default SubscriptionForm;
